import React, { Fragment } from 'react';
import Form from '../../form';
import CommonDataService from '../../../services/CommonDataService';

class LiveVideoDetails extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      serviceTypes: [],
      videoProjectTypes: []
    }
  }

  componentDidMount() {

    CommonDataService
      .getServiceTypes()
      .then(serviceTypes => this.setState({ serviceTypes }));

    CommonDataService
      .getVideoProjectTypes()
      .then(videoProjectTypes => this.setState({ videoProjectTypes }));
  }

  render() {

    return (
      <Fragment>

        <Form.FieldGroup label="Facility name*">
          <Form.Input
            name="liveVideo.facility"
            placeholder="Type facility name" />
          <Form.FieldError name="liveVideo.facility" />
        </Form.FieldGroup>

        <Form.FieldGroup label="Facility address*">
          <Form.Input
            name="liveVideo.address"
            placeholder="Type facility address" />
          <Form.FieldError name="liveVideo.address" />
        </Form.FieldGroup>

        <Form.FieldGroup label="Facility phone*">
          <Form.Input
            name="liveVideo.phone"
            placeholder="Type facility phone" />
          <Form.FieldError name="liveVideo.phone" />
        </Form.FieldGroup>

        <Form.FieldGroup label="Service type*">
          <Form.Dropdown
            name="liveVideo.serviceType"
            options={this.state.serviceTypes}
            multi={false} />
          <Form.FieldError name="liveVideo.serviceType" />
        </Form.FieldGroup>

        <Form.FieldGroup label="Type*">
          <Form.Dropdown
            name="liveVideo.videoProjectType"
            options={this.state.videoProjectTypes}
            multi={false} />
          <Form.FieldError name="liveVideo.videoProjectType" />
        </Form.FieldGroup>

        <Form.FieldGroup label="Two channel audio">
          <Form.Input
            name="liveVideo.twoChannelAudio"
            type="checkbox" />
        </Form.FieldGroup>
      </Fragment>
    );
  }
}

export default LiveVideoDetails;



// WEBPACK FOOTER //
// ./src/components/projects/ProjectForm/LiveVideoDetails.js